import { render, staticRenderFns } from "./FormaPagamentoManageModal.vue?vue&type=template&id=3976efd6&scoped=true"
import script from "./FormaPagamentoManageModal.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoManageModal.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamentoManageModal.vue?vue&type=style&index=0&id=3976efd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976efd6",
  null
  
)

export default component.exports